import React from 'react';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import { NatureOfDamage } from 'cpfr-common';

type NatureOfDamageSelectionProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
};

export const NatureOfDamageSelection: React.FC<NatureOfDamageSelectionProps> = ({ label, name, isMandatory }) => {
    const naturesOfDamage: NatureOfDamage[] = ['Vol', 'Incendie', 'Destruction totale', 'Inondation'];

    const selectItems: ValidatedSelectItem[] = naturesOfDamage.map((natureOfDamage: NatureOfDamage) => {
        return { value: natureOfDamage, label: natureOfDamage };
    });

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            name={name}
            testId={`test-${name}`}
            selectItems={selectItems}
            emptyByDefault
            isMandatory={isMandatory}
            required={isMandatory}
            requiredText=" *"
        />
    );
};
